// extracted by mini-css-extract-plugin
module.exports = {"collapse":"ScreeningResultsModal_collapse__Ooi9r"};